import React, { useState } from 'react'
import { ClickAwayListener } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { fromHex, isHex, toHex } from './theme-model'
import useStyles from './styles'

/**
 * A theme color: up to four suggested swatches (plus the current color when
 * it's not one of them) and a custom color with a hex field.
 */
const ColorField = ({ label, value, suggestions, onChange }) => {
  const classes = useStyles()
  const current = toHex(value)
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState('')

  const swatches = suggestions
    .map(color => color.toUpperCase())
    .filter((color, index, all) => all.indexOf(color) === index)
    .slice(0, 4)
  if (current && !swatches.includes(current)) swatches.push(current)

  const pick = hex => onChange(fromHex(hex.toUpperCase()))

  const toggle = () => {
    setDraft(current || '#015FFB')
    setOpen(value => !value)
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className={classes.field} style={{ position: 'relative' }}>
        <span className={classes.label}>{label}</span>
        <div className={classes.swatches}>
          {swatches.map(color => (
            <button
              key={color}
              type="button"
              title={color}
              className={`${classes.swatch} ${
                color === current ? classes.swatchOn : ''
              }`}
              style={{ background: color }}
              onClick={() => {
                pick(color)
                setOpen(false)
              }}
            />
          ))}
          <button
            type="button"
            title="Custom color"
            className={classes.swatchCustom}
            onClick={toggle}
          >
            <Icon icon="tabler:plus" width={14} height={14} />
          </button>
        </div>
        {open && (
          <div className={classes.picker}>
            <input
              type="color"
              className={classes.pickerColor}
              value={isHex(draft) ? draft : current || '#015FFB'}
              onChange={event => {
                const hex = event.target.value.toUpperCase()
                setDraft(hex)
                pick(hex)
              }}
            />
            <div className={classes.pickerRow}>
              <span className={classes.pickerLabel}>Hex</span>
              <input
                className={classes.pickerHex}
                value={draft}
                placeholder="#015FFB"
                onChange={event => {
                  let hex = event.target.value.trim()
                  if (hex && hex[0] !== '#') hex = `#${hex}`
                  hex = hex.slice(0, 7)
                  setDraft(hex)
                  if (isHex(hex)) pick(hex)
                }}
              />
              <button
                type="button"
                className={classes.pickerDone}
                onClick={() => setOpen(false)}
              >
                Done
              </button>
            </div>
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}

export default ColorField
